import { universalFiltersConfig } from 'MODULES/universal-filters/useUniversalFilters/universalFiltersConfig';
import {
  getNestedKey,
  getNestedKeyValue,
  splitUrlParamKey,
} from 'MODULES/universal-filters/utils/nestedKeysUtils';
import {
  isURLOperator,
  toOperator,
} from 'MODULES/universal-filters/utils/operators';
import {
  BooleanFilterExpression,
  FilterExpression,
  isNumberFilter,
  isNumberFilterType,
  StringFilterExpression,
} from 'MODULES/universal-filters/utils/types';
import { FilterConfig, FilterTypeEnum } from 'SRC/fetch/api/observability';
import { minorToMajor } from 'UTILS/money';

export function parseParams(
  searchParams: URLSearchParams,
  parsedKeys: Set<string>,
  filtersConfig: Map<string, FilterConfig>,
) {
  const setParamsInitialized =
    universalFiltersConfig.getState().setParamsInitialized;

  const searchParamsSize = [...searchParams.keys()].length;
  if (!searchParamsSize && !parsedKeys.size) {
    setParamsInitialized();
    return;
  }
  if (!searchParamsSize && parsedKeys.size) {
    universalFiltersConfig.setState({
      parsedKeys: new Set(),
      universalFilters: new Map(),
    });
    setParamsInitialized();
    return;
  }

  const universalFilters = new Map<string, FilterExpression>();
  const newParsedKeys = new Set<string>();

  for (const key of searchParams.keys()) {
    const { filterKey, urlOperator } = splitUrlParamKey(key);

    if (!filterKey || !urlOperator) {
      continue;
    }

    const filterConfig = filtersConfig.get(getNestedKey(filterKey));
    const operator = isURLOperator(urlOperator) && toOperator(urlOperator);

    if (filterConfig && operator) {
      if (isNumberFilterType(filterConfig.type)) {
        let value = Number(searchParams.get(key));

        const filter = universalFilters.get(filterKey);
        const isCurrency = filterConfig.type === FilterTypeEnum.CURRENCY;
        const filterKeyValue = getNestedKeyValue(filterKey);
        if (isCurrency && filterKeyValue) {
          value = Number(minorToMajor(value, filterKeyValue));
        }

        if (!value || isNaN(value)) {
          continue;
        }

        if (!isNumberFilter(filter)) {
          universalFilters.set(filterKey, {
            type: filterConfig.type,
            values: [[operator, value]],
          });
        } else {
          filter.values.push([operator, value]);
        }
      } else {
        const values = searchParams.getAll(key).filter(Boolean);

        universalFilters.set(filterKey, {
          type: filterConfig.type,
          operator,
          values,
        } as StringFilterExpression | BooleanFilterExpression);
      }
      newParsedKeys.add(key);
    }
  }
  setParamsInitialized();
  universalFiltersConfig.setState({
    parsedKeys: newParsedKeys,
    universalFilters,
  });
}
